<template>
  <div class="home">
    <div class="row">
     <div class="col s12 l9 m10 no-float center-aligned">
      <div class="col s12 input-field">
        <input type="text" id="appSearch" name="appSearch" ref="appSearch" v-model="queryValue" v-on:keyup.enter="$_getSearchResults()">
        <label for="appSearch"></label>
        <button @click="$_getSearchResults()" class="btn-floating transparent z-depth-0 waves-effect action">
          <i class="material-icons grey-text text-darken-3">search</i>
        </button>
      </div>
    </div>
    </div>
    <div class="row">
      
      <div class="col s12 l9 m10 no-float center-aligned">

        <empty-state v-if="results.length < 1"
        data-icon="info"
				:show-button="false"
      >
        <template #header>
					Nothing found 
        </template>
        <template #content>
					<div class="">
						Adjust your search query and try again
					</div>
        </template>		
      </empty-state>

          <div class="card" v-for="post in results" v-bind:key="post.id">
            <div class="card-content">
              <div v-html="post.title.rendered"></div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoriesComponent from '@/components/categories.component'
import contentService from '@/services/contentService'
import emptyState from '@/components/emptyState.component'
export default {
  name: 'search',
  components:{
    // eslint-disable-next-line vue/no-unused-components
    categoriesComponent,
    emptyState
  },
  data(){
    return {
      queryValue:'',
      results:[],
    }
  },
  mounted(){
    this.queryValue = this.$route.query.q
    try{
      this.$route.query.q
      ? this.$_getSearchResults()
      : false
    }catch(err){
      return err
    }
  },
  methods:{
    $_getSearchResults(){     
      contentService.getSearchResults(this.queryValue, 33)
      .then(res=>{
        this.results  = res.data
      })
      .catch(err=>{
        // eslint-disable-next-line no-console
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  min-height: calc(90vh - 56px);
@media screen and (min-width:1024px) {
  width: 100%;
  padding-left:300px;

}
input#appSearch {
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.09), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.02) !important;
    border-radius: 8px;
    margin-top: 34px;
    padding: 0px 24px;
    width: calc(100% - 48px);
}
button.action {
    position: absolute;
    right: 19px;
    bottom: 10px;
}
}
</style>